import React from "react";
import { useNavigate } from "react-router-dom";
import classes from "./Tags.module.css";

function Tags({
  state,
  setter,
  data = [
    { name: "Baseball", count: "231" },
    { name: "Chemistry", count: "141" },
    { name: "Education", count: "100" },
    { name: "Football", count: "63" },
    { name: "Fitness", count: "05" },
    { name: "Sports", count: "51" },
  ],
}) {
  const navigate = useNavigate();
  return (
    <div className={classes.tags}>
      <h3>Tags</h3>
      <ul>
        {data?.map((item, i) => (
          <li
            key={i}
            className={`t-t-c ${[
              state?.name == item?.name ? classes.tagSelected : classes.tag,
            ].join(" ")}`}
            onClick={() => {
              setter(item);
              navigate("/cards", {
                state: item,
              });
            }}
          >{`# ${item?.name}`}</li>
        ))}
      </ul>
      {/* {data?.length > 6 && <span className={classes.viewMore}>View More</span>} */}
    </div>
  );
}

export default Tags;
